// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b50a4f46","455":"79f41896","977":"33f7cfd9"}[chunkId] + ".chunk.js";
};